import * as Constants from "../utils/constants";
import axios from "axios";
const token = localStorage.getItem("token");

if (token) {
  Constants.setAuthToken(token);
}

export const createCookies = async (
  userId,
  functionalCookies,
  personalizationCookies,
  analyticsCookies,
  marketingCookies
) => {
  try {
    const response = await axios.post(
      Constants.COOKIE,
      {
        userId: userId,
        functionalCookies: functionalCookies,
        personalizationCookies: personalizationCookies,
        analyticsCookies: analyticsCookies,
        marketingCookies: marketingCookies,
      },
      Constants.CONFIG
    );
    return response.data;
  } catch (error) {
    return error.message;
  }
};

export const getCookies = async (userId) => {
  try {
    const response = await axios.get(
      `${Constants.COOKIE}/${userId}`,
      Constants.CONFIG
    );

    return response.data;
  } catch (error) {
    console.log(error.response.status);
    return error.response.status;
  }
};

export const updateCookies = async (
  userId,
  functionalCookies,
  personalizationCookies,
  analyticsCookies,
  marketingCookies
) => {
  try {
    const response = await axios.put(
      `${Constants.COOKIE}/${userId}`,
      {
        userId,
        functionalCookies,
        personalizationCookies,
        analyticsCookies,
        marketingCookies,
      },
      Constants.CONFIG
    );
    return response.data;
  } catch (error) {
    return error.message;
  }
};
